export function isIterable<T extends object>(obj: T) {
  if (obj == null) return false;
  return Symbol.iterator in Object(obj);
}
